import { render, staticRenderFns } from "./examineUser.vue?vue&type=template&id=a95ff88a&scoped=true&"
import script from "./examineUser.vue?vue&type=script&lang=js&"
export * from "./examineUser.vue?vue&type=script&lang=js&"
import style0 from "./examineUser.vue?vue&type=style&index=0&id=a95ff88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ff88a",
  null
  
)

export default component.exports